import { render, staticRenderFns } from "./DeliveryRowMobile.vue?vue&type=template&id=4c867320&scoped=true&"
import script from "./DeliveryRowMobile.vue?vue&type=script&lang=ts&"
export * from "./DeliveryRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryRowMobile.vue?vue&type=style&index=0&id=4c867320&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c867320",
  null
  
)

export default component.exports